import { Component, OnInit } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor( public router: Router, public oktaAuth: OktaAuthService ) { }

  async ngOnInit() {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
    /* istanbul ignore next */
    if (isAuthenticated) {
      this.redirectToHomePage();
    }
  }

  redirectToHomePage() {
    this.router.navigate(['/']);
  }

}
